export default {
    namespaced: true,
    state: {
        orderInfo: null,
        submitData: null
    },
    mutations: {
        setUser(state, info) {
            state.orderInfo = info;
        },

        setSubmitData(state, info) {
            state.submitData = info;
        }
    },
    getters: {

    },
    actions: {

    },
    modules: {
        
    }
}